import { PageHero, SectionHeader } from '@/components/common/Sections';
import { TestimonialCard, CTABanner } from '@/components/common/Cards';
import { IMAGES } from '@/lib/constants';
import { useCMS } from '@/lib/useCMS';
import { Star } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

export default function TestimonialsPage() {
  const { testimonials } = useCMS();
  return (
    <div className="page-transition">
      <PageHero title="Testimonials" subtitle="Hear from our happy travelers" backgroundImage={IMAGES.beach} />

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}>
              <div className="text-6xl font-bold font-['Playfair_Display'] text-[#D4AF37] mb-4">4.9</div>
              <div className="flex justify-center gap-1 mb-4">{[...Array(5)].map((_, i) => (<Star key={i} size={28} weight="fill" className="text-[#D4AF37]" />))}</div>
              <p className="text-[#4A5568] text-lg">Based on 4,000+ reviews from happy travelers</p>
            </motion.div>
          </div>
        </div>
      </section>

      <section data-testid="testimonials-grid" className="section-padding bg-[#F5F5F5]">
        <div className="container-custom">
          <SectionHeader overline="Customer Reviews" title="What Our Clients Say" />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">{testimonials.map((testimonial, index) => (<TestimonialCard key={testimonial.id || index} testimonial={testimonial} index={index} />))}</div>
        </div>
      </section>

      <section className="section-padding bg-[#0A1F3D] relative grain-overlay">
        <div className="container-custom relative z-10 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <h2 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] text-white mb-4">Share Your Experience</h2>
            <p className="text-white/70 mb-8 max-w-xl mx-auto">Traveled with Osaka Group? We'd love to hear about your experience.</p>
            <a href="https://g.page/review" target="_blank" rel="noopener noreferrer" data-testid="leave-review-btn" className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-[#0A1F3D] font-semibold hover:bg-[#c5a033]"><Star size={20} weight="fill" />Leave a Google Review</a>
          </motion.div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
